module.exports = __webpack_public_path__ + "img/kwai.6d68438.png";